import { call, put, takeEvery } from 'redux-saga/effects';

// Constants
import { RESPONSE_STATUS_CODES } from '../../constants/common';
import { APPLIED_JOB_STATUS, GET_JOB_APPLICATIONS } from '../../constants/redux';

// Redux-Actions
import { jobApplicationsDetails } from '../slices/jobApplication';

// Api-Services
import { appliedJobStatusApi, getJobApplicationsListApi } from '../apis/jobApplication';

//UtilityPackages
import { toast } from 'react-toastify';
import { apiSuccess } from '../slices/apiStatus';

function* JobApplicationsListSaga(action) {
  try {
    const response = yield call(getJobApplicationsListApi, { ...action.payload });
    if (response?.status === RESPONSE_STATUS_CODES.OK) {
      const result = response.data.data;
      const jobApplications = result.data;
      const pagination = result.pagination;
      yield put(jobApplicationsDetails({ jobApplications, pagination }));
    }
  } catch (error) {
    console.log(error);
  }
}
function* appliedJobStatusSaga(action) {
  try {
    const response = yield call(appliedJobStatusApi, action.payload);
    if (response?.status === RESPONSE_STATUS_CODES.OK) {
      const message = response.data.message;
      toast.success(message, {
        position: toast.POSITION.BOTTOM_RIGHT
      });
      yield call(JobApplicationsListSaga, { payload: action.payload.tableStates });
      yield put(apiSuccess());
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* watcherJobsListSaga() {
  yield takeEvery(GET_JOB_APPLICATIONS, JobApplicationsListSaga);
  yield takeEvery(APPLIED_JOB_STATUS, appliedJobStatusSaga);
}
